import axios from 'axios';
import api from './client'; // Import the shared client

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const difficultyMap = { 1: 'EASY', 2: 'MEDIUM', 3: 'HARD' };


export const getProgress = () => {
    // We pass it as a query parameter
    return api.get(`/progress/user?timezone=${userTimezone}`);
};

export const addXP = (difficulty) => {
  const d = difficultyMap[difficulty] || difficulty; // 2 -> "MEDIUM", "MEDIUM" -> "MEDIUM"
  return api.post(`/progress/user/xp?difficulty=${d}&timezone=${userTimezone}`);
};

export const removeXP = (difficulty) => {
  const d = difficultyMap[difficulty] || difficulty;
  return api.post(`/progress/user/xp/remove?difficulty=${d}&timezone=${userTimezone}`);
};